// store/modules/variables.js
import axios from 'axios';

export default {
    namespaced: true,
    state: {
        isInit: false,
        variables: {},
        values: {}, // { [customVariableId]: { [pageId]: value } }
    },
    mutations: {
        updateVariables(state, variablesArray) {
            state.variables = variablesArray.reduce((acc, variable) => {
                acc[variable.id] = variable;
                return acc;
            }, {});
        },
        updateValues(state, valuesArray) {
            state.values = valuesArray.reduce((acc, value) => {
                if (!acc[value.custom_variable]) acc[value.custom_variable] = {};
                acc[value.custom_variable][value.page] = value.value;
                return acc;
            }, {});
        },
        updateIsInit(state, bool) {
            state.isInit = bool;
        },
    },
    getters: {
        getVariables(state) {
            return state.variables;
        },
        getVariablesList(state) {
            return Object.values(state.variables);
        },
        getValues(state) {
            return state.values;
        },
        // returns [{id, name, value}] for the given page, ready to feed resolveVariables()
        getVariablesForPage: (state) => (pageId) => {
            return Object.values(state.variables).map((variable) => ({
                id: variable.id,
                name: variable.name,
                value: (state.values[variable.id] && state.values[variable.id][pageId]) || '',
            }));
        },
    },
    actions: {
        async fetchVariables({ commit, rootGetters }) {
            // Demo pages have fixed fake variables (see DemoPostCreator.vue) - never fetched, the
            // real endpoint requires auth the demo never has.
            if (rootGetters['demo/isActive']) return

            try {
                const { data } = await axios.get(`${process.env.VUE_APP_API_HOST}/custom-variables`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                });

                commit('updateVariables', data.variables || []);
                commit('updateValues', data.values || []);

                try {
                    localStorage.setItem('variables', JSON.stringify(data.variables || []));
                    localStorage.setItem('variableValues', JSON.stringify(data.values || []));
                } catch (e) {
                    console.error('localStorage quota exceeded, variables cache not updated:', e);
                }
            } catch (error) {
                console.error('Error fetching variables:', error);
            }
        },

        async init({ dispatch, commit }) {
            const cachedVariables = localStorage.getItem('variables');
            const cachedValues = localStorage.getItem('variableValues');

            if (cachedVariables) {
                try {
                    commit('updateVariables', JSON.parse(cachedVariables));
                    commit('updateValues', cachedValues ? JSON.parse(cachedValues) : []);
                } catch (e) {
                    console.error('Invalid variables cache:', e);
                }
                commit('updateIsInit', true);
                dispatch('fetchVariables');
            } else {
                await dispatch('fetchVariables');
                commit('updateIsInit', true);
            }
        },
    },
};
